module.exports = __webpack_public_path__ + "img/40.16528e92.jpg";